module.exports = __webpack_public_path__ + "img/MG-price.08f39778.png";